import numeral from 'numeral';

export const numberFormat = number => numeral(number).format('0,0.00');
